import { Component, Inject } from '@angular/core';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CommonService } from '../services/common.service';
import { LocalStorageSettingsService } from './../../shared/services/local-storage-settings.service';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from "@angular/material/core";


export interface ImportJsonDialogData {
    data: any;
}


@Component({
    selector: 'app-import-json',
    imports: [
    MatFormFieldModule,
    MatInputModule,
    MatSnackBarModule,
    MatOptionModule,
    MatSelectModule
],
    template: `
  <div style="display: flex; flex-direction: column; height: 100%; padding: 0px 0px; box-sizing: border-box;">
    <div class="agGridOuterDiv" style="margin-bottam: 40px;">
      <label i18n="@@spmsUserReg"
        class="textColour"
         style="
           display:inline-block;
           font-weight:500;
           font-size:1.2rem;
          
           border-bottom:2px solid #333;
          
         ">
    {{ screenName }}
  </label>
    </div>
    @if (this.tableName =='mstrobjectgroup') {
      <div >
        <!-- Table selection dropdown -->
        <!-- Table selection dropdown -->
        <div style="display: flex; align-items: center; gap: 10px; margin-top: 25px">
          <label style="font-weight: 500; min-width: 180px; white-space: nowrap;">
            Select Table: <span style="color: red;">*</span>
          </label>
          <mat-form-field appearance="outline" style="width: 280px; margin: 0;">
            <mat-label>Select a Table</mat-label>
            <mat-select
              [(value)]="this.selectedTableName"
              placeholder="Select a Table"
              required>
              <mat-option value="''" disabled>Select a Table</mat-option>
              <mat-option value="mstrobjectgroup">Master Object Group Table</mat-option>
              <mat-option value="objectgroup">Object Group Table</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    }
    <!-- Upload JSON File -->
  
  
  
  
    <div style="display: flex; align-items: center; gap: 10px; margin-top: 25px;">
      <label style="font-weight: 500; min-width: 180px; white-space: nowrap;">
        Upload File For Import:
      </label>
  
      <!-- File name display -->
      <mat-form-field appearance="outline" style="width: 280px; margin: 0;">
        <mat-label>Choose File</mat-label>
        <input matInput placeholder="Choose File" [value]="fileName" readonly>
      </mat-form-field>
  
      <!-- Paperclip icon -->
      <label for="jsonUpload"
    style="cursor: pointer; display: flex; align-items: center; justify-content: center;
           width: 32px; height: 32px; border-radius: 50%; background-color: white;
           border: 1px solid #ddd; box-shadow: 2px 2px 5px rgba(0,0,0,0.2);
           margin-left: 5px;">
        <em class="fas fa-paperclip" style="color: black; font-size: 14px;"></em>
        <input id="jsonUpload" type="file" accept=".json"
          (click)="resetFileInput($event)" (change)="onJsonFileSelected($event)"
          style="display: none;">
        </label>
      </div>
  
  
      <!--
      <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 25px;">
        <label style="font-weight: 500; min-width: 180px; white-space: nowrap;">
          Upload File For Import (mstrobjectgroup):
        </label>
  
        <mat-form-field appearance="outline" style="width: 280px; margin: 0;">
          <mat-label>Choose File</mat-label>
          <input matInput placeholder="Choose File" [value]="fileName" readonly>
        </mat-form-field>
  
        <label for="jsonUpload"
    style="cursor: pointer; display: flex; align-items: center; justify-content: center;
           width: 32px; height: 32px; border-radius: 50%; background-color: white;
           border: 1px solid #ddd; box-shadow: 2px 2px 5px rgba(0,0,0,0.2);
           margin-left: 5px;">
          <em class="fas fa-paperclip" style="color: black; font-size: 14px;"></em>
          <input id="jsonUpload" type="file" accept=".json"
            (click)="resetFileInput($event)" (change)="onJsonFileSelected($event)"
            style="display: none;">
          </label>
        </div>
  
  
        <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 25px; margin-right: 25px;">
          <label style="font-weight: 500; min-width: 180px; white-space: nowrap;">
            Upload File For Import (objectgroup):
          </label>
  
  
          <mat-form-field appearance="outline" style="width: 280px; margin: 0;">
            <mat-label>Choose File</mat-label>
            <input matInput placeholder="Choose File" [value]="fileNameChild" readonly>
          </mat-form-field>
  
  
          <label for="jsonUploadChild"
    style="cursor: pointer; display: flex; align-items: center; justify-content: center;
           width: 32px; height: 32px; border-radius: 50%; background-color: white;
           border: 1px solid #ddd; box-shadow: 2px 2px 5px rgba(0,0,0,0.2);
           margin-left: 5px;">
            <em class="fas fa-paperclip" style="color: black; font-size: 14px;"></em>
            <input id="jsonUploadChild" type="file" accept=".json"
              (click)="resetFileInputChild($event)" (change)="onJsonFileSelectedChild($event)"
              style="display: none;">
            </label>
          </div> -->
  
          <div style="flex: 1;"></div>
  
          <!-- Save & Cancel Buttons -->
    <div style="
    display: flex;
    justify-content: flex-end;
    gap: 16px;
    margin-top: 20px;
    padding: 8px 8px 0 8px;
  ">
  
            <!-- Save -->
            @if (!addBtn) {
              <button
                type="button"
                (click)="confirmAndUpload()"
                class="actionButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
        style="
                width: 180px;
                height: 32px;
                border: 1px solid {{ backgroundColorButton }};
                border-radius: 8px;
                color: white;
                font-weight: 500;
                line-height: 1;
                padding: 0;
              "
                [style.background-color]="backgroundColorButton"
                [disabled]="!file">
                Save
              </button>
            }
  
            <!-- Cancel -->
            <button
              type="button"
              (click)="cancelUpload()"
              class="cancelButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
        style="
           width: 180px;
          height: 32px;
          color: {{ backgroundColorButton }};
          font-weight: 500;
          background-color: white;
          border: 1px solid {{ backgroundColorButton }};
          border-radius: 8px;
          line-height: 1;
          padding: 0;        ">
              Cancel
            </button>
          </div>
        </div>
  `
})
export class ImportJsonComponent {
    file: File | null = null;
    fileName = '';
    fileNameChild = '';
    fileChild: File | null = null;
    addBtn = false;
    tableName;
    selectedTableName="";
    tenantId;
  workspaceId;
  screenName;

    backgroundColorButton = this.localStorageSettings.getSettings('ColorA') || '#49a3ff';

    constructor(
        private commonService: CommonService,
        private localStorageSettings: LocalStorageSettingsService,
        private snackbar: MatSnackBar,
        private spinner: NgxUiLoaderService,
        private dialogRef: MatDialogRef<ImportJsonComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) { }
    ngOnInit(): void {
        console.log(this.data)
        this.tableName = this.data.tablename; 
        this.workspaceId = localStorage.getItem("WorkspaceId");
        if (this.data.tenantid != undefined) {
            this.tenantId = this.data.tenantid
        } else {
            this.tenantId = localStorage.getItem("dnsName");
        

        }
      console.log(this.tenantId, this.tableName, this.workspaceId)
      const screenMap: Record<string, string> = {
        objectmetadata: 'Import Objects',
        mappingconfiguration: 'Import Objects Mapping',
        mappingattributes: 'Import Attributes Mapping',
        field_mapping: 'Import Value Mapping',
        sqlscripts__j: 'Import Source Data Extraction Queries',
        mstrobjectgroup: 'Import Object Group',
        objectgroup: 'Import Object Group',
        loadobjectsmstr: 'Import Load Objects',
        vaultobjectrelationship: 'Import Object Relationship',
        mapping_versions: 'Import Snapshot',
        company:'Import Company',
        mappingtypes:'Import Library List',
        users:'Import User Registration',
        vaultconfigmstr:'Import Data Source Configuration',
        userrolesmstr:'Import User Roles',
        tenantmanagementmstr:'Manage Workspace',
        accesspermission:'Access Management',



        
      };

      this.screenName = screenMap[this.tableName] || '';
      
      
      
    }

    resetFileInput(event: any): void {
        event.target.value = null;
    }
    resetFileInputChild(event: any): void {
        event.target.value = null;
    }

    // ✅ Integrated upload logic
    onJsonFileSelected(event: Event) {
        let selectedTabletEmp = "";
        if (this.tableName == "mstrobjectgroup") {
             selectedTabletEmp = this.selectedTableName;
        }
        const input = event.target as HTMLInputElement;
        if (!input.files || input.files.length === 0) return;

        const file = input.files[0];
        console.log('Selected JSON file:', file);
        // ✅ Check if filename contains tableName
            console.log("FILE NAME--"+file.name)
        const filePrefix = file.name.split('_')[0];

        console.log("tBLE NAME--" + this.tableName)
        console.log("selected table temp NAME--" + selectedTabletEmp)

        if (this.tableName == "mstrobjectgroup") {
            console.log("inside first condition")
            console.log(filePrefix, selectedTabletEmp)
            if (filePrefix.toLowerCase() !== selectedTabletEmp.toLowerCase()) {
                this.snackbar.open(
                    `Selected file name must contain the table name "${selectedTabletEmp}"(Example -> TableName_xyz).`,
                    'OK',
                    { duration: 5000 }
                );
                return;
            }

        } else if (!file.name.toLowerCase().includes(this.tableName.toLowerCase())) {
            console.log("inside !file.name.toLowerCase().includes(this.tableName.toLowerCase()")
            this.snackbar.open(`File name must contain the table name "${this.tableName}"`, 'OK', { duration: 5000 });
            input.value = '';
            return;
        }

        if (!file.name.endsWith('.json')) {
            this.snackbar.open('Please select a valid JSON file (.json)', 'OK', { duration: 5000 });
            input.value = '';
            return;
        }

        this.file = file;
        this.fileName = file.name;
    }
    
    // confirmAndUpload(): void {
    //     console.log(this.file)
    //     if (this.tableName == "mstrobjectgroup") {
    //         this.tableName = this.selectedTableName;
    //     }
    //     if (!this.file) {
    //         this.snackbar.open('Please select a JSON file first.', 'OK', { duration: 4000 });
    //         return;
    //     }

    //     if (!confirm('Do you want to import this JSON file?')) return;

    //     this.spinner.start();
    //   console.log(this.tableName, this.tenantId, this.workspaceId)
    //   this.commonService.retrieveImporExporttHistory(this.tenantId).subscribe(
    //     (response) => {
    //       console.log(response);

    //       const hasInProgress = Array.isArray(response)
    //         ? response.filter(
    //           (item: any) =>
    //             item.status === 'In Progress' && item.tableName === 'mapping_versions'
    //         )
    //         : [];

    //       if (hasInProgress.length > 0) {
    //         this.snackbar.open(
    //           `Import can't be initiated. Please initiate once the existing import completes.`,
    //           'OK',
    //           { duration: 5000 }
    //         );
    //         return; //  Stop execution here
    //       }
    //     }
    //   )

    //     this.commonService.importJsonFile(this.tableName, this.tenantId, this.file, this.workspaceId).subscribe(
    //         (response) => {
    //             console.log('Import response:', response);
    //             this.spinner.stop();
    //             this.snackbar.open('JSON file imported successfully!', 'OK', { duration: 5000 });
    //             // if (this.tableName == "mstrobjectgroup") {
    //             //     this.confirmAndUploadChild();
    //             // }
    //             this.dialogRef.close(true);

    //         },
    //         (error) => {
    //             this.spinner.stop();
    //             console.error('Error importing JSON file:', error);
    //             this.snackbar.open('Error importing JSON file.', 'OK', { duration: 5000 });
    //         }
    //   );
    //   // immediately notify and close dialog
    //   this.spinner.stop();
    //   this.snackbar.open('Import is in progress...', 'OK', { duration: 5000 });
    //   this.dialogRef.close(true);

    //     this.file = null;
    //     this.fileName = '';
  // }
  confirmAndUpload(): void {
    console.log(this.file);

    if (this.tableName === 'mstrobjectgroup') {
      this.tableName = this.selectedTableName;
    }

    if (!this.file) {
      this.snackbar.open('Please select a JSON file first.', 'OK', { duration: 4000 });
      return;
    }

    if (!confirm('Do you want to import this JSON file?')) return;

    this.spinner.start();
    console.log(this.tableName, this.tenantId, this.workspaceId);

    // Step 1: Check for any ongoing imports first
    this.commonService.retrieveImporExporttHistory(this.tenantId).subscribe(
      (response) => {
        console.log(response);

        const hasInProgress = Array.isArray(response)
          ? response.filter(
            (item: any) =>
              item.status === 'In Progress' && item.tableName == this.tableName
          )
          : [];

        if (hasInProgress.length > 0) {
          this.spinner.stop();
          this.dialogRef.close(true);
          this.cancelUpload();
          this.snackbar.open(
            `Import can't be initiated. Please initiate once the existing import completes.`,
            'OK',
            { duration: 5000 }
          );
          return; // Stop execution here
        }

        // Step 2: No "In Progress" imports — start new import
        this.snackbar.open('Import is in progress...', 'OK', { duration: 4000 });
        this.dialogRef.close(true);

        this.commonService
          .importJsonFile(this.tableName, this.tenantId, this.file, this.workspaceId)
          .subscribe(
            (response) => {
              console.log('Import response:', response);
              this.spinner.stop();
              this.snackbar.open('JSON file imported successfully!', 'OK', {
                duration: 5000,
              });

              // Uncomment if you need to chain a child import
              // if (this.tableName == "mstrobjectgroup") {
              //   this.confirmAndUploadChild();
              // }
            },
            (error) => {
              this.spinner.stop();
              console.error('Error importing JSON file:', error);
              this.snackbar.open('Error importing JSON file.', 'OK', {
                duration: 5000,
              });
            }
          );

        // Step 3: Cleanup after triggering import
        this.spinner.stop();
        this.file = null;
        this.fileName = '';
      },
      (error) => {
        this.spinner.stop();
        console.error('Error retrieving import history:', error);
        this.snackbar.open('Error checking import history.', 'OK', { duration: 5000 });
      }
    );
  }

   
    cancelUpload(): void {
        this.file = null;
        this.fileName = '';
        if (this.tableName == "mstrobjectgroup") {
            this.fileChild = null;
            this.fileNameChild = '';
        }
        this.dialogRef.close(false);
    }
}
